import { render, staticRenderFns } from "./DiscountsUpdate.vue?vue&type=template&id=0dc5d784"
import script from "./DiscountsUpdate.vue?vue&type=script&lang=js"
export * from "./DiscountsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports